import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function CustomerGroupDetailsViewModel(logout, groupId) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [group, setGroup] = useState({ customers: [] });


  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getGroup = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(
      `customerGroups/${groupId}`,
      payload
    );
    setLoading(false);
    if (callResult.success) {
      setGroup(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch group");
    }
  };
  const createGroup = async function (values) {
    let callResult = await makePostApiCall(
      `createCustomerGroup`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Customer Group created"
      );
      window.location = "/customer-groups/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not create group");
    }
  };

  const updateGroup = async function (values) {
    let callResult = await makePostApiCall(
      `updateCustomerGroups/${groupId}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Customer Group updated"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not update group");
    }
  };

  return {
    createGroup,
    updateGroup,
    getGroup,
    group,
    loading,
    emptyModal,
    setEmptyModelOpen,
  };
}
